import React from 'react';
import {Link} from "react-scroll";
//Image... 
import HeaderImg from '../images/HeaderImg.png'

export const Hero = () => {
    return (
        <main>
            <section className='hero-section' id='hero' style={{backgroundImage: `url(${HeaderImg})`}}>
                <div className='hero-overlay'>
                    <div className='section-content'>
                        <div className='hero-details'>
                            <h1 className='title'>
                                Car Trouble? We Come to You – Phoenix and Surrounding Areas
                            </h1>

                            <p className='description'>
                                At A Plus Roadside Rescue, we specialize in fast, professional mobile mechanic services across Phoenix and surrounding areas. Whether your vehicle won’t start, is overheating, or needs urgent repairs, our experienced technicians are ready to help — anytime, anywhere.
                            </p>
                            
                            <div className='buttons'>
                                <Link activeClass='active' to='contact' spy={true} smooth={true} offset={-90} duration={500} className='button primary-button'>
                                    Get Help Fast
                                </Link>
                                <Link activeClass='active' to='about' spy={true} smooth={true} offset={-90} duration={500} className='button secondary-button'>
                                    Learn More
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    )
}